module.exports = __webpack_public_path__ + "img/cardmodel.07eb04e8.png";